import { render, staticRenderFns } from "./BQdtCard.vue?vue&type=template&id=4fa205e1&scoped=true"
import script from "./BQdtCard.vue?vue&type=script&lang=js"
export * from "./BQdtCard.vue?vue&type=script&lang=js"
import style0 from "./BQdtCard.vue?vue&type=style&index=0&id=4fa205e1&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fa205e1",
  null
  
)

export default component.exports